import React from 'react'
import './style.css'

import { Link, Router, Switch, Route } from 'react-router-dom'
import Test from './test';
import Game from './DndGame';

import Bottom from '../../img/TalkLandingPage/Bottom.png'
import Top from '../../img/TalkLandingPage/Top.png'
import Middle from '../../img/TalkLandingPage/Middle.png'



import T from '../../img/Talk/T.png'
import A from '../../img/Talk/A.png'
import L from '../../img/Talk/L.png'
import K from '../../img/Talk/K.png'

export default class extends React.Component {
  constructor (props) {
    super(props)
  }


  render () {
    return (
      <Switch>
        <Route path='/youth/talk/test' component={Test} />
        <Route path='/youth/talk/game' component={Game} />
        <Route exact path='/youth/talk' render={() => {
          return(
            <div className='page-container' style={{"marginTop": "25px"}}>
                <div className="talk-container"> 
                    <img src={T} className='talk-img'/>
                    <p className="talk-text"><b>TELL</b> others about how you are feeling, unless you open up to others it is hard for them to understand what you are going through and offer support.</p>
                    <img src={A} className='talk-img'/>
                    <p className="talk-text"><b>ASK</b> for help when you need it, don’t be embarrassed or ashamed of your mental health. You deserve to feel better.</p>
                    <img src={L} className='talk-img'/>
                    <p className="talk-text"><b>LISTEN</b> to yourself, your thoughts and your body. Accept and don’t ignore uncomfortable thoughts or feelings. Listen to others who are in distress.</p>
                    <img src={K} className='talk-img'/>
                    <p className="talk-text"><b>KINDNESS</b> and respect to others is important in developing communities which support well-being. Ask how your friends are if you notice they are upset.</p>
                </div>
                <img src={Top} className='top-img'/>
                <img src={Middle} className='middle-img'/>
                <img src={Bottom} className='bottom-img'/>
                <Link className="download-btn" to="/youth/talk/test">Test Your Knowledge</Link>
                <Link className="download-btn" to="/youth/talk/game">Play a Game</Link>
            </div>
          )
        }} />
      </Switch>
    )
  }
}


class Panel extends React.Component {
  constructor (props) {
    super(props)
    this.props = props
  }

  render () {
  return (
      <div className="container convo-container">
        <div className="panel panel-default convo-panel">
          <div className="panel-heading heading-convos">{this.props.title}</div>
          <div className="panel-body convo-list">
            <ul style={{ 'list-style': 'none', "padding-left": "10px" }}>
              {this.props.body}
            </ul>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Talk/index.js